module.exports = __webpack_public_path__ + "img/4.776bf8db.jpg";